/* eslint-disable @typescript-eslint/no-explicit-any */
import api from '@/services/api';

interface Result {
  success: boolean;
  message: string;
  token: string;
  user: {
    id?: number;
    name: string;
    email: string;
    isAdmin: boolean;
  };
}

export async function serviceLogin(email: string, password: string) {
  try {
    const response = await api.post<Result>('/login', { email, password });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Erro ao fazer login');
    }
    throw new Error('Erro de conexão com o servidor');
  }
}
